"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('components/selectBox/selectBox',["require", "exports", "text!./selectBox.html", "knockout"], function (require, exports, templateMarkup, ko) {
    "use strict";
    /// <amd-dependency path='text!./selectBox.html' name='templateMarkup' />

    var SelectBox = function () {
        function SelectBox(params) {
            _classCallCheck(this, SelectBox);

            this.keyName = 'key';
            this.valueName = 'value';
            this.hasFocus = ko.observable(false);
            this.showDropDown = ko.pureComputed(this.computeShowDropDown, this);
            this.selectedKey = ko.pureComputed(this.computeSelectedKey, this);
            this.selected = ko.pureComputed(this.computeSelectedKey, this);
            this.label = '';
            this.placeholder = '';
            this.multipleSelectionEnabled = false;
            this.keyName = params.key || 'key';
            this.valueName = params.value || 'value';
            this.options = ko.isObservable(params.options) ? params.options : ko.observableArray(params.options);
            this.selectedOption = ko.isObservable(params.selectedOption) ? params.selectedOption : ko.observable(params.selectedOption);
            this.selectedOptions = ko.isObservable(params.selectedOptions) ? params.selectedOptions : ko.observableArray(params.selectedOptions);
            this.selectionCallback = params.selectionCallback;
            this.focusCallback = params.focusCallback;
            this.label = params.label;
            this.placeholder = params.placeholder;
            this.multipleSelectionEnabled = params.multipleSelectionEnabled || false;
            this.disabled = ko.isObservable(params.disabled) ? params.disabled || ko.observable(false) : ko.observable(params.disabled);
        }

        _createClass(SelectBox, [{
            key: "computeSelectedKey",
            value: function computeSelectedKey() {
                return this.selectedOption() ? this.selectedOption()[this.keyName] !== undefined && this.selectedOption()[this.keyName] !== null ? ko.isObservable(this.selectedOption()[this.keyName]) ? this.selectedOption()[this.keyName]() : this.selectedOption()[this.keyName] : this.selectedOption() : '';
            }
        }, {
            key: "getKey",
            value: function getKey(option) {
                if (option[this.keyName] !== undefined && option[this.keyName] !== null) {
                    return option[this.keyName];
                }
                return option;
            }
        }, {
            key: "focus",
            value: function focus() {
                this.hasFocus(true);
            }
        }, {
            key: "toggleFocus",
            value: function toggleFocus() {
                this.hasFocus(!this.hasFocus());
            }
        }, {
            key: "blur",
            value: function blur() {
                setTimeout(function () {
                    this.hasFocus(false);
                }.bind(this), 300);
            }
        }, {
            key: "lostFocus",
            value: function lostFocus() {
                this.hasFocus(false);
            }
        }, {
            key: "computeShowDropDown",
            value: function computeShowDropDown() {
                var source = this.options();
                return !this.disabled() && this.hasFocus() /* && source.length > 0*/;
            }
        }, {
            key: "optionSelected",
            value: function optionSelected(option) {
                if (!this.multipleSelectionEnabled) {
                    this.selectedOption(option);
                    this.hasFocus(false);
                }
                if (this.selectionCallback) {
                    this.selectionCallback(option);
                }
                return true;
            }
        }, {
            key: "removeOption",
            value: function removeOption(option) {
                this.selectedOptions.remove(option);
                if (this.selectionCallback) {
                    this.selectionCallback(option);
                }
            }
        }]);

        return SelectBox;
    }();

    return { viewModel: SelectBox, template: templateMarkup };
});
//# sourceMappingURL=selectBox.js.map;
